module.exports = __webpack_public_path__ + "img/sm-my.c2e79766.png";